module.exports = __webpack_public_path__ + "img/checkmark.273f9daf.svg";